import { useTechs } from './useTechs'
import { useTechRegions } from './useTechRegions'
import { useSchedulingWizard } from '../../wizardContext'

export function useFormData() {
  const [{ branchId, response }] = useSchedulingWizard()

  const showNoResultsError = response?.count === 0

  const techOptions = useTechs(branchId)
  const techRegionOptions = useTechRegions()
  return {
    techOptions,
    techRegionOptions,
    showNoResultsError,
  }
}
